import React from "react";
import { Button, Stack } from "@mui/material";

// "Show more" under a paged list, with how many are still hidden.
const ShowMoreButton = ({ remaining, label, onClick, sx }) =>
  remaining > 0 ? (
    <Stack alignItems="center" sx={{ mt: 2, ...sx }}>
      <Button
        variant="outlined"
        onClick={onClick}
        sx={{ textTransform: "none", borderRadius: "8px" }}
      >
        {label} ({remaining})
      </Button>
    </Stack>
  ) : null;

export default ShowMoreButton;
